import React from 'react';
import PropTypes from 'prop-types';
import { MenuLeafNode } from './menu-nodes/MenuLeafNode';
import { MenuParentNode } from './menu-nodes/MenuParentNode';
import { I18nUtils } from '../../../../../../../i18n/I18nUtils';
import { PsRoutes } from '../../../../../routing/Routes';

export const AdminMenu = (
    {
        displayTasks,
        displayListerias,
        displayNewTask,
    },
) => {
    return (
        <React.Fragment>
            <MenuLeafNode
                icon={'home'}
                label={I18nUtils.tr('TR_INICIO')}
                route={PsRoutes.HOME}
                activeRoutes={[PsRoutes.HOME]}
            />
            <MenuParentNode
                icon={'account_box'}
                label={I18nUtils.tr('TR_USUARIOS')}
                activeRoutes={[
                    PsRoutes.USERS,
                    PsRoutes.USERS_ADD,
                    PsRoutes.USERS_DETAIL,
                ]}
            >
                <MenuLeafNode
                    label={I18nUtils.tr('TR_NUEVO_USUARIO')}
                    route={PsRoutes.USERS_ADD}
                    activeRoutes={[PsRoutes.USERS_ADD]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TODOS_LOS_USUARIOS')}
                    route={PsRoutes.USERS}
                    activeRoutes={[PsRoutes.USERS, PsRoutes.USERS_DETAIL]}
                />
            </MenuParentNode>
            <MenuParentNode
                icon={'work'}
                label={I18nUtils.tr('TR_MIS_CONTRATISTAS')}
                activeRoutes={[
                    PsRoutes.MY_CONTRACTORS,
                    PsRoutes.MY_CONTRACTORS_DOCUMENTS,
                    PsRoutes.MY_CONTRACTORS_DOCUMENTS_DETAIL,
                    PsRoutes.MY_CONTRACTORS_WORKS,
                    PsRoutes.MY_CONTRACTORS_WORKS_DETAIL,
                    PsRoutes.MY_CONTRACTORS_WORKERS,
                    PsRoutes.MY_CONTRACTORS_WORKERS_ADD,
                    PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL,
                    PsRoutes.MY_CONTRACTORS_WORKERS_DOCUMENTS_DETAIL,
                    PsRoutes.MY_CONTRACTORS_MACHINES,
                    PsRoutes.MY_CONTRACTORS_MACHINES_ADD,
                    PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL,
                    PsRoutes.MY_CONTRACTORS_MACHINES_DOCUMENTS_DETAIL,
                ]}
            >
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TODOS_LOS_CONTRATISTAS')}
                    route={PsRoutes.MY_CONTRACTORS}
                    activeRoutes={[PsRoutes.MY_CONTRACTORS]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_DOCUMENTOS')}
                    route={PsRoutes.MY_CONTRACTORS_DOCUMENTS}
                    activeRoutes={[
                        PsRoutes.MY_CONTRACTORS_DOCUMENTS,
                        PsRoutes.MY_CONTRACTORS_DOCUMENTS_DETAIL,
                        PsRoutes.MY_CONTRACTORS_WORKERS_DOCUMENTS_DETAIL,
                        PsRoutes.MY_CONTRACTORS_MACHINES_DOCUMENTS_DETAIL,
                    ]}
                />
                <MenuParentNode
                    label={I18nUtils.tr('TR_TRABAJADORES')}
                    activeRoutes={[
                        PsRoutes.MY_CONTRACTORS_WORKERS_ADD,
                        PsRoutes.MY_CONTRACTORS_WORKERS,
                        PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_NUEVO_TRABAJADOR')}
                        route={PsRoutes.MY_CONTRACTORS_WORKERS_ADD}
                        activeRoutes={[PsRoutes.MY_CONTRACTORS_WORKERS_ADD]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_TODOS_LOS_TRABAJADORES')}
                        route={PsRoutes.MY_CONTRACTORS_WORKERS}
                        activeRoutes={[PsRoutes.MY_CONTRACTORS_WORKERS, PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL]}
                    />
                </MenuParentNode>
                <MenuParentNode
                    label={I18nUtils.tr('TR_MAQUINARIA')}
                    activeRoutes={[
                        PsRoutes.MY_CONTRACTORS_MACHINES,
                        PsRoutes.MY_CONTRACTORS_MACHINES_ADD,
                        PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_NUEVA_MAQUINARIA')}
                        route={PsRoutes.MY_CONTRACTORS_MACHINES_ADD}
                        activeRoutes={[PsRoutes.MY_CONTRACTORS_MACHINES_ADD]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_TODA_LA_MAQUINARIA')}
                        route={PsRoutes.MY_CONTRACTORS_MACHINES}
                        activeRoutes={[PsRoutes.MY_CONTRACTORS_MACHINES, PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL]}
                    />
                </MenuParentNode>
                <MenuLeafNode
                    label={I18nUtils.tr('TR_OBRAS')}
                    route={PsRoutes.MY_CONTRACTORS_WORKS}
                    activeRoutes={[PsRoutes.MY_CONTRACTORS_WORKS, PsRoutes.MY_CONTRACTORS_WORKS_DETAIL]}
                />
            </MenuParentNode>
            <MenuParentNode
                icon={'work_outline'}
                label={I18nUtils.tr('TR_MIS_SUBCONTRATAS')}
                activeRoutes={[
                    PsRoutes.MY_OUTSOURCES_WORKS,
                    PsRoutes.MY_OUTSOURCES_WORKS_ADD,
                    PsRoutes.MY_OUTSOURCES_WORKS_DETAIL,
                    PsRoutes.MY_OUTSOURCES,
                    PsRoutes.MY_OUTSOURCES_ADD,
                    PsRoutes.MY_OUTSOURCES_MACHINES,
                    PsRoutes.MY_OUTSOURCES_WORKERS,
                    PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL,
                    PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_DETAIL,
                    PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL,
                    PsRoutes.MY_OUTSOURCES_MONTHLY,
                    PsRoutes.MY_OUTSOURCES_TASKS,
                    PsRoutes.MY_OUTSOURCES_TASKS_ADD,
                    PsRoutes.MY_OUTSOURCES_PAPER_BIN_RECOVER,
                    PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY,
                    PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS,
                    PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL,
                ]}
            >
                <MenuLeafNode
                    label={I18nUtils.tr('TR_NUEVA_SUBCONTRATA')}
                    route={PsRoutes.MY_OUTSOURCES_ADD}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_ADD]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TODAS_LAS_SUBCONTRATAS')}
                    route={PsRoutes.MY_OUTSOURCES}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES, PsRoutes.MY_OUTSOURCES_DETAIL]}
                />
                <MenuParentNode
                    label={I18nUtils.tr('TR_DOCUMENTOS')}
                    activeRoutes={[
                        PsRoutes.MY_OUTSOURCES_DOCUMENTS,
                        PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL,
                        PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES,
                        PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES,
                        PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL,
                        PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL,
                        PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_TODOS_LOS_DOCUMENTOS')}
                        route={PsRoutes.MY_OUTSOURCES_DOCUMENTS}
                        activeRoutes={[
                            PsRoutes.MY_OUTSOURCES_DOCUMENTS,
                            PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL,
                            PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL,
                            PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL,
                        ]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_TIPOS_DE_DOCUMENTOS')}
                        route={PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES, PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_ESQUEMAS_DE_DOCUMENTOS')}
                        route={PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES]}
                    />
                </MenuParentNode>
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TRABAJADORES')}
                    route={PsRoutes.MY_OUTSOURCES_WORKERS}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_WORKERS, PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_MAQUINARIA')}
                    route={PsRoutes.MY_OUTSOURCES_MACHINES}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_MACHINES, PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL]}
                />
                <MenuParentNode
                    label={I18nUtils.tr('TR_OBRAS')}
                    activeRoutes={[
                        PsRoutes.MY_OUTSOURCES_WORKS,
                        PsRoutes.MY_OUTSOURCES_WORKS_ADD,
                        PsRoutes.MY_OUTSOURCES_WORKS_DETAIL,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_NUEVA_OBRA')}
                        route={PsRoutes.MY_OUTSOURCES_WORKS_ADD}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_WORKS_ADD]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_TODAS_LAS_OBRAS')}
                        route={PsRoutes.MY_OUTSOURCES_WORKS}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_WORKS, PsRoutes.MY_OUTSOURCES_WORKS_DETAIL]}
                    />
                </MenuParentNode>
                <MenuLeafNode
                    label={I18nUtils.tr('TR_MENSUAL')}
                    route={PsRoutes.MY_OUTSOURCES_MONTHLY}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_MONTHLY]}
                />
                {displayListerias &&
                    <MenuParentNode
                        label={I18nUtils.tr('TR_LISTERIAS')}
                        activeRoutes={[
                            PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY,
                            PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS,
                            PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL,
                        ]}
                    >
                        <MenuLeafNode
                            label={I18nUtils.tr('TR_LISTERIA_MENSUAL')}
                            route={PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY}
                            activeRoutes={[PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY]}
                        />
                        <MenuLeafNode
                            label={I18nUtils.tr('TR_GESTIONAR_PRESENCIAS')}
                            route={PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS}
                            activeRoutes={[PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS, PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL]}
                        />
                    </MenuParentNode>
                }
                {
                    displayTasks ? (
                        <MenuParentNode
                            label={I18nUtils.tr('TR_TAREAS')}
                            activeRoutes={[
                                PsRoutes.MY_OUTSOURCES_TASKS,

                            ]}>
                            {displayNewTask ? <MenuLeafNode
                                label={I18nUtils.tr('TR_NUEVA_TAREA')}
                                route={PsRoutes.MY_OUTSOURCES_TASKS_ADD}
                                activeRoutes={[PsRoutes.MY_OUTSOURCES_TASKS_ADD]}
                            /> : null}
                            <MenuLeafNode
                                label={I18nUtils.tr('TR_TODAS_LAS_TAREAS')}
                                route={PsRoutes.MY_OUTSOURCES_TASKS}
                                activeRoutes={[PsRoutes.MY_OUTSOURCES_TASKS]}
                            />
                        </MenuParentNode>
                    ) : null
                }
                <MenuParentNode
                    label={I18nUtils.tr('TR_PAPELERA')}
                    activeRoutes={[
                        PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE,
                        PsRoutes.MY_OUTSOURCES_PAPER_BIN_RECOVER,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_ELIMINAR')}
                        route={PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_RECUPERAR')}
                        route={PsRoutes.MY_OUTSOURCES_PAPER_BIN_RECOVER}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_PAPER_BIN_RECOVER]}
                    />
                </MenuParentNode>
            </MenuParentNode>
        </React.Fragment>
    );
};

AdminMenu.propTypes = {
    contractor: PropTypes.object.isRequired,
    displayTasks: PropTypes.bool.isRequired,
    displayListerias: PropTypes.bool.isRequired,
};

AdminMenu.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/menus-by-role/AdminMenu.jsx